import { Controller } from '@hotwired/stimulus'

// Manages the event form. Currently handles URL blur for auto-scraping.
// AI description generation will be added when LLM provider is configured.
export default class extends Controller {
  static targets = []
}
